import V2Drawer from '@/common/components/Feedback/V2Drawer';
import { FC } from 'react';
import SpotSurveyDetail from './index';

/**
 * 踩点记录详情抽屉
 * @Description
 */
const SpotSurveyDetailDrawer:FC<{
  drawerData: { open, id },
  onClose,
  isSjtb?: boolean;
}> = ({ drawerData, onClose, isSjtb }) => {
  return (
    <V2Drawer
      bodyStyle={{ padding: 0 }}
      destroyOnClose
      open={drawerData.open}
      onClose={() => onClose()}
    >
      {drawerData.open && <SpotSurveyDetail id={drawerData.id} isSjtb={isSjtb}/>}
    </V2Drawer>
  );
};

export default SpotSurveyDetailDrawer;
